import { css } from 'styled-system/css';
import { center, flex } from 'styled-system/patterns';

export const matchStyles = {
	match: css({
		base: {
			_mdBelow: {
				'& .match-time, .match-time-live': {
					_fontSizeBase: {
						fontSize: '10px',
					},
				},
				'& .bettype-title': {
					_fontSizeBase: {
						fontSize: '10px',
					},
				},
			}
		},
		_mars: {
			flexDirection: 'column',
			borderRadius: 'inherit',
			borderTop: '1px solid token(colors.black.5)',
			overflow: 'hidden',
			'& .match-slide__item': {
				height: '18px',
			},
			'& .match-slide__item:nth-child(2)': {
				mt: '-18px',
			},
			'& .match-time': {
				fontSize: '12px',
				color: 'black.1',
				lineHeight: '1',
			},
			'& .match-time-live': {
				fontSize: '13px',
				color: 'black.1',
			},
			'& .match-live': {
				fontWeight: '400',
			},
			'& .match-live .text-primary': {
				color: 'minus.text'
			},
			'& .scoreboard': {
				margin: '6px',
				width: 'auto',
				backgroundColor: 'scoreboard.bg',
				border: '1px solid {colors.scoreboard.border}',
				'& .scoreboard__cell-heading': {
					color: 'black.2',
					backgroundColor: 'black.5',
				},
				'& [class^=scoreboard__col]': {
					color: 'black.1',
					'& .scoreboard__text--base': {
						color: 'black.2',
						bgColor: 'black.5',
					},
					'& .scoreboard__text-group': {
						'--scoreboard-cell-heading-text': 'currentColor',
					// color: 'black.1',
					},
				},
			},
		},
	}),
	matchHeader: flex({
		_mars: {
			maxHeight: '45px',
			alignItems: 'center',
			overflow: 'hidden',
			w: '100%',
			pl: '9px',
			gap: '9px',
		}
	}),
	statsMini: flex({
		_mars: {
			flex: 'none',
			flexDirection: 'column',
			height: 'auto',
			lineHeight: '1.2',
			gap: '1px',
			alignItems: 'center',
			'& .match-live': {
				fontWeight: '400',
			},
			'& .match-live .text-primary': {
				color: 'minus.text'
			},
		}
	}),
	teamsMini: flex({
		_mars: {
			flex: '1',
			flexDirection: 'column',
		}
	}),
	teamMini: flex({
		_mars: {
			width: '100%',
			height: 'auto',
		}
	}),
	teamNameMini: css({
		_mars: {
			WebkitLineClamp: '1',
			// width: '100%',
			// overflow: 'hidden',
			// textOverflow: 'ellipsis',
			// whiteSpace: 'nowrap',
			// minWidth: '0',
		}
	}),
	score: css({
		_mars: {
			color: 'secondary.600',
			fontWeight: 'bold',
			flex: '0 0 auto',
			fontSize: '14px',
		}
	}),
	timeMachineButton: css({
		_mars: {
			color: 'black.3',
			_hover: {
				color: 'black.2',
			},
		}
	}),
	matchContent: flex({
		_mars: {
			width: '100%',
			position: 'relative',
			overflow: 'hidden',
		}
	}),
	event: flex({
		_mars: {
			flex: '0 0 130px',
			flexDirection: 'column',
			// minWidth: '130px',
			// maxWidth: '180px',
			// width: 'min(40%, 200px)',
			md: {
				flex: '0 0 180px',
			}
		}
	}),
	stats: css({
		_mars: {
			backgroundImage: 'linear-gradient(90deg, hsla(0, 0%, 100%, 0) 0, hsl(token(colors.primary.h), 59%, 90%) 60%)',
			position: 'relative',
			height: '30px',
			padding: '4px 16px 4px 6px',
			fontSize: '14px',
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'flex-start',
			mb: '3px',
			gap: '6px',
			_after: {
				content: '""',
				position: 'absolute',
				right: '0',
				top: '0',
				width: '0',
				height: '0',
				borderStyle: 'solid',
				borderWidth: '0 0 30px 16px',
				borderColor: 'transparent transparent token(colors.white.1) transparent',
			},
		},
		_dark: {
			backgroundImage: 'linear-gradient(90deg, token(colors.primary.200_0) 0, token(colors.primary.300_12) 60%)',
			_after: {
				borderColor: 'transparent transparent token(colors.match.bg) transparent',
			}
		},
	}),
	info: flex({
		_mars: {
			flex: '0 0 auto',
			padding: '8px 3px 9px 3px',
			position: 'relative',
			alignItems: 'flex-start',
			color: 'black.3',
			gap: '3px',
			'& .btn--icon': {
				w: '20px',
				h: '20px',
				flex: 'none',
				// margin: '-6px 0',
				color: 'black.3',
			},
			'& .icon, .cashout-icon': {
				w: '20px',
				h: '20px',
			},
			'& .icon--mini-streaming': {
				w: '18px',
				h: '18px',
			},
		},
	}),
	option: css({
		_mars: {
			display: 'inline-flex',
			alignItems: 'center',
			flexWrap: 'wrap',
			marginRight: 'auto',
			gap: '3px',
			'& .btn--icon[data-active="true"]': {
				color: 'secondary.500',
			}
		}
	}),
	miniStreamingButton: css({
		_mars: {
			mt: '1px',
			flex: '1 0 32px',
			maxWidth: '60px',
			h: '18px',
			minHeight: 'auto',
			p: '0 6px',
			color: 'streaming.button.text',
			border: '1px solid {colors.black.4}',
			borderRadius: '24px',
			'&[data-open="true"]': {
				borderColor: '#F36D6D',
			},
			lgx: {
				display: 'none',
			}
		}
	}),
	teams: flex({
		_mars: {
			flexDirection: 'column',
			justifyContent: 'center',
			padding: '3px 3px 0 6px',
			cursor: 'pointer',
		}
	}),
	team: flex({
		_mars: {
			alignItems: 'flex-start',
			fontSize: '14px',
			wordBreak: 'break-word',
			height: '39px',
			// marginBottom: '3px',
			// mb: '4px'
		}
	}),
	teamName: css({
		base: {
			_mdBelow: {
				_fontSizeBase: {
					fontSize: '12px',
				},
			},
		},
		_mars: {
			// display: '-webkit-box',
			// overflow: 'hidden',
			WebkitLineClamp: '2',
			// textOverflow: 'ellipsis',
			// boxOrient: 'vertical',
			alignItems: 'flex-start',
			// maxHeight: '3em', 
			lineHeight: '18px',
			height: '36px',
		}
	}),
	teamStrong: css({
		color: 'match.teamStrong',
	}),
	teamRed: css({
		color: 'match.teamRed',
	}),
	teamBlue: css({
		color: 'match.teamBlue',
	}),
	redcard: center({
		height: '15px',
		padding: '0 3px',
		fontSize: '12px',
		verticalAlign: 'middle',
		position: 'relative',
		marginLeft: '2px',
		marginTop: '1px',
	}),
	teamScore: css({
		_mars: {
			marginLeft: 'auto',
			flex: '0 0 auto',
			padding: '1px 2px',
			minWidth: '24px',
			lineHeight: '1',
			fontSize: '16px',
			fontWeight: '700',
			textAlign: 'center',
			backgroundColor: 'var(--match-team-score-bg)',
			border: '1px solid var(--match-team-score-border)',
			borderRadius: 'var(--border-radius-md)',
		}
	}),
	oddsTable: flex({
		_mars: {
			flex: '1 1 auto',
			flexDirection: 'column',
			overflow: 'hidden',
			position: 'relative',
			paddingBottom: '6px',
		},
		'& .swiper': {
			w: '100%',
		}
	}),
	bettypeWraper: css.raw({
		_mars: {
			display: 'flex',
			overflowX: 'auto',
			whiteSpace: 'nowrap',
			scrollBehavior: 'smooth',
			// overscrollBehavior: 'contain',
			// scrollSnapType: 'x mandatory',
			_scrollbar: {
				display: 'none',
			}
		}
	}),
	bettypes: flex.raw({
		_mars: {
			// paddingBottom: '12px',
			minWidth: '100%',
			display: 'inline-flex',
			verticalAlign: 'top',
			position: 'relative',
			// scrollSnapAlign: 'start',
			// minHeight: '119px',
			'&[data-more-lines="true"]': {
				minHeight: '162px',
			},
			lg: {
				minWidth: '50%'
			},
		},
	}),
	bettype: css.raw({
		_mars: {
			flex: '0 0 auto',
			padding: '0 2px',
			width: '33.33%',
			minWidth: '60px',
		},
		'& .odds-button': {
			flexDirection: 'column',
			mb: '6px',
			h: '39px',
		},
		'& .odds-button__goal': {
			flex: 'none',
		},
		'& .odds-button__odds': {
			ml: '0',
			marginTop: '3px',
		},
	}),
	bettypeTitle: center({
		_mars: {
			flex: '0 0 auto',
			marginBottom: '3px',
			padding: '0 6px',
			textAlign: 'center',
			p: '2px',
			backgroundColor: 'transparent',
			height: '30px',
			lineHeight: '1.2em',
			fontSize: '12px',
			color: 'bettypeTitle.text',
			whiteSpace: 'normal',
			// overflow: 'hidden',
			// textOverflow: 'ellipsis',
			// display: '-webkit-box',
			// WebkitLineClamp: '2',
			// boxOrient: 'vertical',
			paddingTop: '3px',
			'& .multi-line-ellipsis': {
				maxHeight: 'inherit',
				WebkitLineClamp: '2',
			},
		},
	}),
	asialine: center({
		'&[data-direction=end]': {
			_ltr: {
				left: '2px',
			},
			_rtl: {
				right: '2px',
			},
		},
			
		'&[data-direction=start]': {
			_ltr: {
				right: '2px',
			},
			_rtl: {
				left: '2px',
			},
		},

		_mars: {
			whiteSpace: 'normal',
			width: 'calc((100% / 3) * 2 - 4px)',
			minWidth: '100px',
			height: '39px',
			fontSize: '12px',
			color: 'black.1',
			// backgroundImage: 'var(--btn-more-lines-img)',
			// borderWidth: '1px',
			// borderColor: 'odds.border',
			boxShadow: 'inset 0 0 0 1px token(colors.oddsTable.border)',
			bgColor: 'oddsTable.bg',
			borderRadius: '6px',
			position: 'absolute',
			// bottom: '10px',
			top: '123px',
			p: '3px 6px',
			textAlign: 'center',
			cursor: 'pointer',
			
			'&[data-full-width="true"]': {
				// width: '99%',
				width: 'calc((100% / 2) * 2 - 4px)',
			}
		}
	}),
	// for baseball AIO 
	noTeamNameMoreLine: center({
		top: '0px',
		position: 'relative',
		w: '100%',
		height: '39px',
		fontSize: '12px',
		color: 'black.1',
		boxShadow: 'inset 0 0 0 1px token(colors.oddsTable.border)',
		bgColor: 'oddsTable.bg',
		borderRadius: '6px',
		p: '3px 6px',
		textAlign: 'center',
		cursor: 'pointer',
	}),
	pagination: css({
		_mars: {
			width: '100%',
			marginTop: 'auto',
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'center',
			pointerEvents: 'none',
			pt: '3px',
			// position: 'absolute',
			// bottom: '4px',
			'& ul': {
				margin: '0',
				padding: '0',
				listStyle: 'none',
				display: 'flex',
				'& li': {
					width: '5px',
					height: '5px',
					margin: '0 2px',
					borderRadius: '50%',
					backgroundColor: 'black.3',
					'&[data-status="is-active"]': {
						backgroundColor: 'brand.500',
					}
				}
			},
			lg: {
				display: 'none',
			}
		}
	}),
	moreOption: flex({
		minWidth: '28px',
		flexDirection: 'column',
		// alignItems: 'center',
		// justifyContent: 'flex-start',
		flex: '0 0 auto',
		boxSizing: 'content-box',
	}),
	iconButtons: css({
		flex: '1',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		flexDirection: 'column',
		padding: '1px 1px 6px 1px',
		marginLeft: '-1px',
		gap: '3px',
	}),
	arrowButton: flex({
		flex: 'none',
		width: '30px',
		height: '30px',
		cursor: 'pointer',
		color: 'black.3',
		_hover: {
			color: 'black.2',
		},
		'& .icon': {
			width: '20px',
			height: '20px',
		}
	}),
	iconButton: flex({
		color: 'whiteOpacity.100',
		bgColor: 'brand.400',
		border: '1px solid token(colors.brand.500)',
		borderRadius: '6px',
		fontSize: '12px',
		fontWeight: '500',
		lineHeight: '15px',
		w: '28px',
		h: '28px',
		transition: 'transform .2s',
		_hover: {
			transform: 'scale(1.1)',
		},
	}),
	iconButtonTimeMachine: css({
		_mars: {
			color: 'whiteOpacity.100',
			bgColor: 'brand.500',
			border: '1px solid token(colors.brand.500)',
			borderRadius: '6px',
			fontSize: '12px',
			fontWeight: '500',
			lineHeight: '15px',
			w: '28px',
			h: '28px',
			transition: 'transform .2s',
			_hover: {
				transform: 'scale(1.1)',
			},
			'&[data-open=true]': {
				bgColor: 'brand.400',
			}
		}
	}),
	// More Asian Lines
	moreLine: css({
		position: 'absolute',
		top: 0,
		left: 0,
		right: 0,
		bottom: 0,
		display: 'flex',
		bgColor: 'match.bg',
		transform: 'translateY(100%)',
		transition: 'transform 200ms ease-in',
		zIndex: '1',
		_active: {
			transform: 'translateY(0)',
		},
		'& .match-stats': {
			borderBottom: '1px solid {colors.brand.500_light}',
			bg: 'none!',
			_after: {
				display: 'none',
			},
		},
		'& .match-info': {
			'paddingTop': '13px',
		}
	}),
	moreLineTab: css({
		height: '30px',
		width: '100%',
		mb: '3px',
		overflowX: 'auto',
		overflowY: 'hidden',
		flex: '0 0 auto',
		_scrollbar: {
			display: 'none',
		},
	}),
	// for baseball AIO 
	moreLineTabBaseball: css({
		mb: '9px',
	}),
	
	moreLineSlide: css({
		w: '100%',
		'& .swiper-slide': {
			w: 'auto'
		}
	}),

	moreLineTabContainer: css({
		position: 'relative',
		minW: '100%!',
		display: 'inline-flex',
		alignItems: 'flex-start',
		gap: '3px',
		pt: '6px',
		pr: '6px',
		_after: {
			content: '""',
			position: 'absolute',
			height: '1px',
			left: 0,
			bottom: 0,
			right: 0,
			bgColor: 'brand.500_light',
		},
	}),
	moreLineTabItem: css({
		position: 'relative',
		border: '1px solid {colors.primary.500}',
		bgColor: 'primary.500',
		p: '2px 6px',
		lineHeight: '15px',
		rounded: '6px',
		whiteSpace: 'nowrap',
		zIndex: 1,
		color: 'whiteOpacity.100',
		cursor: 'pointer',
		_active: {
			color: 'brand.500_light',
			bgColor: 'match.bg',
			border: '1px solid {colors.brand.500_light}',
			rounded: '6px 6px 0 0',
			height: '24px',
			_after: {
				content: '""',
				position: 'absolute',
				height: '6px',
				left: 0,
				bottom: '-6px',
				right: 0,
				bgColor: 'match.bg',
				zIndex: 2,
			}
		}
	}),
	moreLineBettypeWraper: css.raw({
		scrollSnapType: 'unset!',
		// '& .odds-button': {
		// 	height: '48px!',
		// }
	}),
	moreLineBettypes: css.raw({
		md: {
			minW: '100%!',
			display: 'inline-flex',
			overflowX: 'auto',
			_scrollbar: {
				height: '8px',
				bgColor: 'var(--s600)',
			},
			_scrollbarThumb: {
				bgColor: 'var(--s800)',
				border: '1px solid var(--s600)',
				rounded: '6px',
			},
			_scrollbarTrack: {
				bgColor: 'var(--s600)',
			},
		}
	}),
	moreLineBettype: css.raw({
		minW: '56px',
		maxW: '100px',
		width: '16.666%!',
		md: {
			maxW: '100px',
		}
	}),
	moreLineFooter: css({
		mt: '6px',
		mx: '3px',
		'&.baseball-aio-footer': {
			mt: '0px',
		}
	}),
	closeButton: css({
		position: 'relative',
		width: '100%',
		minH: '24px',
		fontWeight: 'normal',
		_dark: {
			color: 'whiteOpacity.54',
			borderColor: 'whiteOpacity.12'
		},
		'& .icon': {
			position: 'absolute',
			right: '3px',
			width: '20px',
			height: '20px',
		}
	}),
}